"use client"

import { m } from "framer-motion"
import { cn } from "@/lib/utils"

export interface BarSegment {
  value: number
  color: string
  opacity?: number
  label?: string
}

export interface SegmentedBarProps {
  segments: BarSegment[]
  height?: number
  gap?: number
  className?: string
}

export function SegmentedBar({
  segments,
  height = 6,
  gap = 3,
  className,
}: SegmentedBarProps) {
  const total = segments.reduce((sum, s) => sum + s.value, 0)
  if (total === 0) return null

  return (
    <div className={cn("flex w-full", className)} style={{ height, gap }}>
      {segments.map((segment, i) => {
        const widthPercent = (segment.value / total) * 100
        return (
          <m.div
            key={i}
            initial={{ width: 0 }}
            animate={{ width: `${widthPercent}%` }}
            transition={{
              duration: 0.8,
              ease: [0.16, 1, 0.3, 1],
              delay: 0.2 + i * 0.12,
            }}
            title={segment.label}
            style={{
              backgroundColor: segment.color,
              opacity: segment.opacity ?? 1,
              minWidth: 8,
              flexShrink: 0,
            }}
            className="rounded-full"
          />
        )
      })}
    </div>
  )
}
